import { useEffect, useRef } from 'react';
import { useLang } from '../i18n';
import HeroCanvas from './HeroCanvas';
import MascotSVG from './MascotSVG';

const PHONE_HREF = 'tel:+18059229684';
const MAPS_HREF = 'https://www.google.com/maps/dir/?api=1&destination=926+W+Main+St,+Santa+Maria,+CA+93458';

function PhoneIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13.5a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 2.66h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L7.91 10.1a16 16 0 0 0 6 6l.91-1.91a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
    </svg>
  );
}

function MapIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
      <circle cx="12" cy="10" r="3"/>
    </svg>
  );
}

export default function Hero() {
  const heroRef = useRef();
  const { t } = useLang();

  useEffect(() => {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion) return;
    const handler = () => {
      const scrolled = window.pageYOffset;
      const mascot = document.querySelector('.hero-mascot-float');
      if (mascot) mascot.style.transform = `translateY(${scrolled * 0.12}px)`;
    };
    window.addEventListener('scroll', handler, { passive: true });
    return () => window.removeEventListener('scroll', handler);
  }, []);

  return (
    <section className="hero-section" data-testid="hero-section" ref={heroRef}>
      <div className="hero-accent" aria-hidden="true" />
      <div className="hero-inner">
        <div className="hero-copy">
          <div className="hero-badge">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="var(--sm-blue)" aria-hidden="true">
              <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"/>
            </svg>
            {t.heroBadge}
          </div>
          <h1 className="hero-h1">
            {t.heroH1_1}<br />{t.heroH1_2}
            <br /><span className="red hero-subtitle-line">{t.heroSubtitle}</span>
          </h1>
          <p className="hero-subhead">{t.heroSubhead}</p>
          <ul className="hero-bullets">
            <li>{t.heroBullet1}</li>
            <li>{t.heroBullet2}</li>
            <li>{t.heroBullet3}</li>
            <li>{t.heroBullet4}</li>
            <li>{t.heroBullet5}</li>
          </ul>
          <div className="hero-ctas">
            <a href={PHONE_HREF} className="btn-primary btn-lg" data-testid="hero-call-cta" aria-label="Call Super Muffler Inc.">
              <PhoneIcon />
              {t.heroCallCta}
            </a>
            <a href={MAPS_HREF} target="_blank" rel="noopener noreferrer" className="btn-secondary btn-lg" data-testid="hero-directions-cta" aria-label="Get directions">
              <MapIcon />
              {t.heroDirectionsCta}
            </a>
          </div>
        </div>
        <div className="hero-canvas-col">
          <HeroCanvas />
        </div>
      </div>
    </section>
  );
}
